const ToitureBanner = () => {

    return(
        <>
            <section className="be-banner">
                <div className="">
                    <p className="be-banner-title">CHIFFRAGE : CHARPENTE TRADITIONNELLE</p>
                    <p className="be-centered-p">TOITURE ET SOUS-TOITURE</p>
                </div>
            </section>
        </>
    )

}

export default ToitureBanner;